var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { "no-gutters": "" } },
    [
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "v-autocomplete",
            {
              attrs: {
                chips: _vm.chips,
                clearable: _vm.clearable && !_vm.readonly,
                disabled: _vm.disabled,
                "error-messages": _vm.selectValidation,
                filter: _vm.noFilter,
                items: _vm.items,
                label: _vm.label,
                loading: _vm.loading,
                "menu-props": _vm.menuProps,
                multiple: _vm.multiple,
                placeholder: _vm.placeholder,
                rules: _vm.rules,
                "search-input": _vm.search,
                readonly: _vm.readonly,
                "validate-on-blur": ""
              },
              on: {
                "update:searchInput": function($event) {
                  _vm.search = $event
                },
                "update:search-input": function($event) {
                  _vm.search = $event
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "item",
                  fn: function(data) {
                    return [
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", {
                            domProps: { innerHTML: _vm._s(data.item.text) }
                          })
                        ],
                        1
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.select,
                callback: function($$v) {
                  _vm.select = $$v
                },
                expression: "select"
              }
            },
            [
              _c(
                "template",
                { slot: "no-data" },
                [
                  _c(
                    "v-list-item",
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("components.locationAjaxSelect.noData")
                                ) +
                                " "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }